<template>
  <div id="projectStepCheck">
    <div class="stepContainer">
      <!-- 搜索行 -->
      <div class="searchRow">
        <el-cascader
          :modal-append-to-body="false"
          @change="handleSetpSearchChange"
          class="tableSearch"
          filterable
          clearable
          style="width:20%"
          v-model="search_stage_code_arr"
          :options="stage_code_list"
          placeholder="请选项目阶段"
        ></el-cascader>
        <el-select
          class="tableSearch"
          style="width:20%"
          v-model="searchClass"
          filterable
          placeholder="请选择项目负责部门"
        >
          <el-option
            v-for="item in classList"
            :key="item.department_id"
            :label="item.department_name"
            :value="item.department_id"
          ></el-option>
        </el-select>
        <el-select
          class="tableSearch"
          style="width:20%"
          v-model="search_permit_type"
          filterable
          placeholder="请选择许可类型"
        >
          <el-option
            v-for="item in permit_type_list"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          class="tableSearch"
          style="width:20%"
          v-model="search_permit_type_sub"
          filterable
          placeholder="请选择行业类型"
        >
          <el-option
            v-for="item in permit_type_sub_list"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <div class="btnCol">
          <el-button class="creat" @click="handleSearchClick" style="background-color:#40A0F2;">查看</el-button>
        </div>
      </div>
      <div class="stepShowBox">
        <div style="margin-top:20px;" class="mindItem">
          <span style="border-radius: 25px;background-color: rgb(48, 173, 95);" class="itemText">开始</span>
        </div>
        <div class="mindItem" v-for="item in stepShowList">
          <span class="itemText">{{item.name}}</span>
        </div>
        <div class="mindItem noLine">
          <span style="border-radius: 25px;background-color:#f4a029" class="itemText">结束</span>
        </div>
      </div>
    </div>
  </div>
</template> 
<script>
export default {
  name: 'projectIndex',
  data() {
    return {
      member_id: '',
      token: '',
      company_id: '',
      cache_department_id: '',
      stepShowList: [],
      classList: [],
      searchClass: '',
      search_permit_type: '',
      search_permit_type_sub: '',
      search_stage_code: '',
      project_id_search: '',
      search_stage_code_arr: [],
      permit_type_list: [
        { label: '一般类', value: '1' },
        { label: '许可类', value: '2' },
      ],
      permit_type_sub_list: [],
      stage_code_list: [
        {
          value: '1',
          label: '立项',
          children: [
            {
              value: '11',
              label: '项目登记',
            },
            {
              value: '12',
              label: '项目分配',
            },
            {
              value: '13',
              label: '风险分析',
            },
            {
              value: '14',
              label: '项目组任命书',
            },
            {
              value: '15',
              label: '工作计划',
            },
          ],
        },
        {
          value: '2',
          label: '现场调查',
          children: [
            {
              value: '21',
              label: '现场勘察记录',
            },
            {
              value: '22',
              label: '整改通知单',
            },
            {
              value: '23',
              label: '整改复查记录表',
            },
          ],
        },
        {
          value: '3',
          label: '三级审查',
          children: [
            {
              value: '311',
              label: '项目内部审核意见表',
            },
            {
              value: '312',
              label: '修改回复表',
            },
            {
              value: '321',
              label: '技术负责人审核表',
            },
            {
              value: '322',
              label: '技术负责人审核修改回复表',
            },
            {
              value: '323',
              label: '过程控制负责人审核表',
            },
            {
              value: '324',
              label: '过程控制负责人修改回复表',
            },
          ],
        },
        {
          value: '4',
          label: '外部审查',
          children: [
            {
              value: '33',
              label: '外部审查（非必须）',
            },
          ],
        },
        {
          value: '5',
          label: '报告盖章',
          children: [
            {
              value: '44',
              label: '资质/印章使用申请',
            },
          ],
        },
        {
          value: '5',
          label: '存档',
          children: [
            {
              value: '24',
              label: '委托方提供材料清单',
            },
            {
              value: '51',
              label: '项目档案存档清单',
            },
          ],
        },
      ],
    }
  },

  methods: {
    handleSetpSearchChange(val) {
      if (val.length > 0) {
        this.search_stage_code = val[val.length - 1]
      }
    },
    async handleSearchClick() {
      this.stepShowList = []
      // console.log('searchClass', this.searchClass)
      // console.log('search_permit_type', this.search_permit_type)
      // console.log('search_permit_type_sub', this.search_permit_type_sub)
      // console.log('search_stage_code', this.search_stage_code)

      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)

      param.append('stage_code', this.search_stage_code)
      param.append('project_id', this.project_id_search)
      param.append('project_type', this.searchClass)
      param.append('permit_type', this.search_permit_type)
      param.append('permit_type_sub', this.search_permit_type_sub)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/get_stage_charge',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      console.log('res.datas', res.datas)
      // this.stepShowList =
      res.datas.list1.forEach((item) => {
        var strUser = ''
        item.forEach((items) => {
          strUser += items.nickname + '/'
        })
        this.stepShowList.push({
          name: strUser.substring(0, strUser.length - 1),
        })
      })
      if (res.datas.list2.length > 0) {
        var strUser2 = ''
        res.datas.list2.forEach((item) => {
          strUser2 += item.nickname + '/'
        })
        this.stepShowList.push({
          name: strUser2.substring(0, strUser2.length - 1) + '(抄送)',
        })
      }
      console.log('this.stepShowList', this.stepShowList)
    },
  },
  activated() {
    this.stepShowList = []
    this.searchClass = ''
    this.search_permit_type = ''
    this.search_permit_type_sub = ''
    this.search_stage_code = ''
    this.project_id_search = ''
    this.search_stage_code_arr = []

    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.search_stage_code = this.$route.query.stage_code || ''
    this.project_id_search = this.$route.query.project_id || ''
    console.log('this.stage_code_search', this.stage_code_search)
    console.log('this.project_id_search', this.project_id_search)
    // **获取部门列表
    let params = new URLSearchParams()
    params.append('member_id', this.member_id)
    params.append('token', this.token)
    if (this.$store.state.process.app.deviceInfo) {
      params.append('device', this.$store.state.process.app.deviceInfo)
    } else {
      params.append('device', 'pc')
    }
    params.append('company_id', this.company_id)
    params.append('cache_department_id', this.cache_department_id)
    this.$axios({
      method: 'post',
      url: '/api/Project/is_business_department',
      data: params,
    }).then((ress) => {
      if (ress.data.code != 200) return this.$message.error(ress.datas.msg)
      this.classList = ress.data.datas.listInfo
      // if (this.classList.length > 0)
      //   this.addFormData.department_id = this.classList[0].department_id
      if (this.search_stage_code && this.project_id_search) {
        this.handleSearchClick()
      }
      console.log('部门列表', this.classList)
    })
  },
  async created() {},
  watch: {
    search_permit_type(val, oldval) {
      if (val == '1') {
        this.permit_type_sub_list = []
        this.search_permit_type_sub = ''
      }
      if (val == '2') {
        this.permit_type_sub_list = [
          { label: '危化', value: '1' },
          { label: '冶金', value: '2' },
          { label: '矿山', value: '3' },
        ]
        this.search_permit_type_sub = ''
      }
    },
    // $route: {
    //   handler(val, oldVal) {
    //     if (
    //       val.path == '/project/index'
    //       // val.path == '/project/attention' ||
    //       // val.path == '/project/save' ||
    //       // val.path == '/project/classify'
    //     ) {
    //       if (val.query.type) {
    //         this.PorjectType = val.query.type
    //       } else {
    //         this.PorjectType = ''
    //       }
    //       this.getProjectTypeList()
    //     }
    //   },

    //   deep: true,
    // },
  },
}
</script>
<style lang="less" scoped>
#projectStepCheck {
  box-sizing: border-box;
  padding: 30px;
  height: 100%;
  .stepContainer {
    border-radius: 10px;
    box-shadow: 1px 5px 9px 0px rgb(3 70 126 / 14%);
    width: 100%;
    height: 100%;
    background-color: #fff;
    box-sizing: border-box;
    padding: 20px 30px;
    .searchRow {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 20px;
      /deep/.tableSearch {
        width: 450px;
        // (deep)
        .el-input__inner {
          height: 45px;
          border-radius: 24px;
          font-size: 16px;
          border: none;
          background-color: #f4f5f6;
          color: #333;
          &::placeholder {
            color: #333;
          }

          &::-webkit-input-placeholder {
            /* WebKit browsers 适配谷歌 */
            color: #333;
          }

          &:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 适配火狐 */
            color: #333;
          }
        }
      }
      .btnCol {
        display: flex;
        align-items: center;
        /deep/.el-button {
          font-size: 18px;
          font-weight: normal;
          border: none;
          width: 130px;
          height: 45px;
          background: #f4a029;
          color: #fff;
          border-radius: 24px;
          padding: 0;
          margin-left: 30px;
        }
        img {
          cursor: pointer;
          margin-left: 30px;
        }
      }
    }
    .stepShowBox {
      width: 100%;
      height: calc(100% - 65px);
      overflow-y: auto;
      .mindItem {
        position: relative;
        box-sizing: border-box;
        // width: 300px;
        display: flex;
        justify-content: center;
        font-size: 16px;
        // margin: 0 auto;
        margin-bottom: 40px;
        .itemText {
          padding: 0 40px;
          background-color: #40a0f2;
          color: #fff;
          height: 50px;
          line-height: 50px;
          border-radius: 10px;
        }
      }
      .mindItem::before {
        content: '';
        position: absolute;
        left: 50%;
        top: 50px;
        width: 2px;
        height: 40px;
        background-color: #40a0f2;
      }
      .noLine::before {
        content: '';
        display: none;
      }
    }
  }
}

// 修改时间线样式
/deep/ .projectTime {
  margin-left: 100px;
  .el-timeline-item__content {
    padding: 20px 0 0px;
  }
  /deep/.el-timeline-item__timestamp.is-top {
    font-size: 18px;
    color: #128bf1;
    font-weight: 700;
    padding-top: 0;
  }
  .stepItem {
    display: flex;
    box-sizing: border-box;
    padding-left: 50px;
    margin-bottom: 15px;
    p {
      font-size: 16px;
    }
  }

  // 半透明圆环
  .eltimelinefocus {
    // 线
    .el-timeline-item__tail {
      border-color: #40a0f2;
    }
    .el-timeline-item__node {
      // border: 3px solid hsla(0, 0%, 90%, 0.8);
      border: 3px solid #cbe0ff;
      background-clip: content-box;
      background: rgba(78, 151, 255, 1);
    }
    .el-timeline-item__node--normal {
      left: -3px;
      top: -3px;
      width: 11px;
      height: 11px;
    }
  }
  // 半透明圆环
  .eltimelineNofocus {
    // 线
    .el-timeline-item__tail {
      border-left: 2px dashed #e3e3e3;
    }
    .el-timeline-item__node {
      // border: 3px solid hsla(0, 0%, 90%, 0.8);
      border: 3px solid #efefef;
      background-clip: content-box;
      background: #ddd;
    }
    .el-timeline-item__node--normal {
      left: -3px;
      top: -3px;
      width: 11px;
      height: 11px;
    }
  }
}
// 修改弹窗样式
// dialog弹窗
/deep/.el-dialog {
  border-radius: 10px;
  .el-dialog__header {
    border-radius: 10px 10px 0 0;
    background-color: #f4f5f6;
    font-size: 20px;
    color: #333;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 40px;
  }
}
.stepDia {
  /deep/.el-dialog {
    min-width: 750px;
    margin-top: 10vh !important;
    margin-bottom: 0;
    .el-dialog__body {
      padding: 20px 20px;
      padding-bottom: 10px;
    }
  }
}
.table__body::-webkit-scrollbar {
  width: 5px !important;
}
.table__body::-webkit-scrollbar-track {
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
/* 滚动条滑块 */
.table__body::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}
/deep/.diaHistoryBox {
  height: 70vh;
  overflow-y: auto;
  .projectTime {
    padding: 10px 0;
  }
}
</style>
